module.exports = __webpack_public_path__ + "static/media/split.8b142da5.png";